import { useState, useEffect, useContext } from "react";
import VideoThumbnail from "/componentry/Videos/Thumbnail";
import LoadingThumbnail from "/componentry/Videos/LoadingThumbnail";
import InfiniteScroll from "react-infinite-scroll-component";
import ClientSort from "/componentry/Videos/Sort/ClientSort";
import TeamSort from "/componentry/Videos/Sort/TeamSort";
import FavouriteSort from "/componentry/Videos/Sort/FavouriteSort";
import TypeSort from "/componentry/Videos/Sort/TypeSort";
import FeedSort from "/componentry/Videos/Sort/FeedSort";
import { PagewideContext } from "/componentry/Root/Shared/PagewideContext.jsx";
import { server, vClasses } from "/lib/publicEnv";
import Link from "next/link";
import Image from "next/image";
import { FaArrowLeft, FaFilter } from "react-icons/fa";
import { useRouter } from "next/router";

import { fetchClients } from "/lib/helpers";

import { stringify } from "qs";

const defaultSortMap = {
    "relevance": "relevance",
    "chronological-descend": "newest-first",
    "chronological-ascend": "oldest-first",
    "most-viewed": "most-views",
    "least-viewed": "least-views",
};

const userMetaDefault = {
    id: null,
    name: null,
    avatar: null,
    editor: false,
    active: false
};


export default function Videos() {
    const [ defaultFilters ] = useState({
        client: null,
        editor: null,
        type: "unsorted",
        favourite: false,
        sort: "newest-first"
    });

    const router = useRouter();
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [more, setMore] = useState(true);
    const [videoType, setVideoType] = useState("unsorted");
    const [filtersChanged, setFiltersChanged] = useState(false);
    const [totalSearchResults, setTotalSearchResults] = useState(0);
    const [filters, setFilters] = useState({
        client: null,
        editor: null,
        type: "unsorted",
        favourite: false,
        sort: "newest-first"
    });
    const [videoTypeLoading, setVideoTypeLoading] = useState(false);
    const [ userMeta, setUserMeta ] = useState(userMetaDefault);
    const { pageContext, setPageContext } = useContext(PagewideContext);
    
    const sortExpression = {
        route: videoType == "videos" ? "getVideos" : videoType == "shorts" ? "getShorts" : "getUnsorted",
        name: videoType == "videos" ? "Videos" : videoType == "shorts" ? "Shorts" : "Videos & shorts"
    };

    const sortStr = stringify({
        team: filters.editor !== null ? filters.editor : undefined,
        favourite: filters.favourite == true ? true : undefined,
        client: filters.client !== null ? filters.client : undefined,
        sort: defaultSortMap[filters.sort || "chronological-descend"] !== "" ? defaultSortMap[filters.sort || "chronological-descend"] : undefined,
        type: videoType == "videos" ? "video" : videoType == "shorts" ? "short" : "all"
    });

    async function fetchVideos(initial) {
        if (initial && videos.length !== 0) return;
        const res = await fetch(
            `${server}/api/content/search?start=${videos.length}&limit=${initial ? 40 : 20}${sortStr !== "" ? `&${sortStr}` : ""}`
        ).then(res => res.json()).catch(err => console.log(err));
        let videoArr = res.hits?.hits?.map(m => m._source);
        if (((res?.hits?.total?.value - videos?.length) - res.hits?.hits?.length) <= 0) setMore(false);
        else setMore(true);
        
        let shownVideos = [];
        setVideos((video) => [...video, ...videoArr].filter((v) => {
            if (shownVideos.includes(v.id)) return false;
            shownVideos.push(v.id);
            return true;
        }));
    };

    async function fetchInitialVideos(initial, vtl, customFilter) {
        if (initial && !vtl && videos.length !== 0) return;
        if (vtl) {
            setTotalSearchResults(0);
            setVideoTypeLoading(true);
            setLoading(true);
        };

        let fStr = sortStr;
        if (customFilter) fStr = stringify({
            team: customFilter.editor !== null ? customFilter.editor : undefined,
            favourite: customFilter.favourite == true ? true : undefined,
            client: customFilter.client !== null ? customFilter.client : undefined,
            sort: customFilter.sort ? customFilter.sort : undefined,
            type: customFilter.type == "videos" ? "video" : customFilter.type == "shorts" ? "short" : "all"
        });
        const res = await fetch(`${server}/api/content/search/?start=0&limit=${initial ? 40 : 20}${fStr !== "" ? `${fStr !== "" ? `&${fStr}` : ""}` : ""}`).then(res => res.json()).catch(err => console.log(err));
        console.log(`${server}/api/content/search/?start=0&limit=${initial ? 40 : 20}${fStr !== "" ? `${fStr !== "" ? `&${fStr}` : ""}` : ""}`)
        if (initial && res.hits?.hits?.length >= 40) setTotalSearchResults(((res?.hits?.total?.value) - res.hits?.hits?.length) + 40);
        if (initial && res.hits?.hits?.length < 40) setTotalSearchResults(res.hits?.hits?.length);
        let videoArr = res.hits?.hits?.map(m => m._source);
        if (((res?.hits?.total?.value) - res.hits?.hits?.length) <= 0) setMore(false);
        else setMore(true);
        
        let shownVideos = [];
        setVideos((video) => [...video, ...videoArr].filter((v) => {
            if (shownVideos.includes(v.id)) return false;
            shownVideos.push(v.id);
            return true;
            // check if last video
        }));

        if (vtl) {
            setVideoTypeLoading(false);
        };

        if (customFilter) {
            setVideoType(customFilter.type);
            setFilters(customFilter);
        };
    };

    async function parseInitialFilter(q) {
        const clientele = await fetchClients({}, true);
        // kudos from https://stackoverflow.com/questions/14226803/wait-5-seconds-before-executing-next-line

        //const clientele = await fetchClients({ context: { state: pageContext, setState: setPageContext, loading }, bigClients: false }, true);
        //if (!clientele.find(c => c.id === q.client)) q.client = defaultFilters.client;

        let newFilters = filters;
        if (q.client) {
            const client = clientele.find(c => c.id === q.client);
            if (client) {
                setUserMeta({
                    active: true,
                    editor: false,
                    name: client.name,
                    avatar: client.thumbnail?.default?.url
                });
                newFilters.client = q.client;
            };
        };
        if (q.editor) {
            if (!q.client) {
                setUserMeta({
                    active: true,
                    editor: true,
                    name: q.editor === "team" ? "Continuity" : "Kooleyy",
                    avatar: q.editor === "team" ? "/images/continuity.png" : "/images/kooleyy.png",
                });
            };
            newFilters.editor = q.editor;
        };
        if (q.favourite) newFilters.favourite = q.favourite;
        if (q.type) {
            newFilters.type = q.type;
            setVideoType(q.type);
        };

        if (q.sort) {
            newFilters.sort = defaultSortMap[q.sort] || "chronological-descend";
        };

        console.log(newFilters)
        
        fetchInitialVideos(true, false, newFilters).then(() => setLoading(false));

        return true;
    };

    useEffect(() => {
        if (router.isReady && loading && !videoTypeLoading) {
            (async () => {
                let filteredQueries = Object.keys(router.query).filter((e) => e !== "q");
                let sanitisedQueries = {};
                if (filteredQueries.length > 0) {
                    filteredQueries.forEach((e) => {
                        let val = router.query[e];
                        if (e === "client") {
                            sanitisedQueries[e] = val;
                        } else if (e === "editor") {
                            // check if team exists
                            if (val !== "solo" && val !== "team") return;
                            sanitisedQueries[e] = val;
                        } else if (e === "type") {
                            if (val !== "unsorted" && val !== "videos" && val !== "shorts") return;
                            sanitisedQueries[e] = val;
                        } else if (e === "sort") {
                            let sortArr = Object.keys(defaultSortMap);
                            if (!sortArr.includes(val)) return;
                            sanitisedQueries[e] = val;
                        } else if (e === "favourite") {
                            // parse to boolean
                            sanitisedQueries[e] = val === "true";
                        };

                        return true;
                    });
                };

                if (Object.keys(sanitisedQueries).length > 0) {
                    await parseInitialFilter(sanitisedQueries);
                } else {
                    await fetchInitialVideos(true, false).then(() => setLoading(false));
                };

                setPageContext({ ...pageContext, carry: { ...pageContext.carry, submitSearchDisabled: false } });
            })();
        };
    }, [router.isReady]);

    useEffect(() => {
        if (router.isReady) {
            fetchClients({ context: { state: pageContext, setState: setPageContext, loading }, bigClients: false });
        };
    }, [router.isReady]);

    useEffect(() => {
        if (router.isReady && videoTypeLoading && !loading) {
            let f = filters;
            let filterStr = "";
            let filterObj = Object.keys(f);

            filterObj = filterObj.filter((e) => {
                if (f[e] === defaultFilters[e]) return false;
                if (f[e] === null && e === "client") return false;
                return true;
            });

            filterStr = stringify({
                ...filterObj.reduce((obj, key) => ({ ...obj, [key]: f[key] }), {})
            });

            setVideos([]);
            fetchInitialVideos(true, true).then(() => setLoading(false));
            router.push(`/v/${filterStr !== "" ? `?${filterStr}` : ""}`, undefined, { shallow: true });
            setPageContext({ ...pageContext, carry: { ...pageContext.carry, submitSearchDisabled: false }, filters: { changed: filtersChanged, filters, defaultFilters } });
        };
    }, [videoTypeLoading]);

    useEffect(() => {
        let keys = Object.keys(filters);
        let changed = false;
        keys.forEach((e) => {
            if (filters[e] !== defaultFilters[e]) {
                changed = true;
            }
        });

        setFiltersChanged(changed);
    }, [filters, loading]);

    const filterDiv = (
        <>
            <div className="flex flex-row gap-x-4 gap-y-4 items-center">
                <FavouriteSort onClick={(() => {
                    if (videoTypeLoading) return;
                    setFilters({
                        ...filters,
                        favourite: !filters.favourite
                    });
                    setVideoTypeLoading(true);
                })} current={filters.favourite} />
                <TypeSort onClick={((c) => {
                    if (videoTypeLoading) return;
                    setFilters({
                        ...filters,
                        type: c
                    });
                    setVideoType(c);
                    setVideoTypeLoading(true);
                })} current={videoType} />
            </div>
            <div className="flex flex-row gap-x-4 gap-y-4 items-center">
                <ClientSort clients={pageContext?.carry?.clients} onClick={((o) => {
                    if (videoTypeLoading) return;
                    if (o == null) {
                        setFilters({
                            ...filters,
                            client: null
                        });
                        if (userMeta.active && filters.editor) {
                            setUserMeta({
                                active: true,
                                name: filters.editor == "solo" ? "Kooleyy" : "Continuity",
                                avatar: filters.editor == "solo" ? "/kooleyy.png" : "/continuity.png",
                                editor: true
                            });
                        } else {
                            setUserMeta(userMetaDefault);
                        };
                        setVideoTypeLoading(true);
                        return;
                    } else {
                        const clientUser = pageContext?.carry?.clients.find((c) => c.id == o);
                        setFilters({
                            ...filters,
                            client: o || null
                        })
                        setUserMeta({
                            active: true,
                            name: clientUser.name,
                            avatar: clientUser.thumbnail.default.url,
                            editor: false
                        });
                    };
                    setVideoTypeLoading(true);
                })} current={filters.client} />
                <TeamSort onClick={((o) => {
                    if (videoTypeLoading) return;
                    switch (o) {
                        case "team":
                            if (userMeta.active && !userMeta.editor) break;
                            setUserMeta({
                                active: true,
                                name: "Continuity",
                                avatar: "/continuity.png",
                                editor: true
                            });
                            break;
                        
                        case "solo":
                            if (userMeta.active && !userMeta.editor) break;
                            setUserMeta({
                                active: true,
                                name: "Kooleyy",
                                avatar: "/kooleyy.png",
                                editor: true
                            });
                            break;
                        
                        default:
                            if (userMeta.active && !userMeta.editor) break;
                            setUserMeta(userMetaDefault);
                            break;
                    };
                    setFilters({
                        ...filters,
                        editor: o || null
                    })
                    setVideoTypeLoading(true);
                })} current={filters.editor} />
            </div>
        </>
    );

    return (
        <main className="flex flex-col gap-y-4 px-12 py-4 pt-8 md:py-12 text-white font-BreezeHeader font-bold sm:items-start">
            <div className="flex flex-row justify-between w-full gap-y-4 items-center">
                <div className="flex flex-col gap-y-4 items-start">
                    <div className="md:flex md:flex-row items-center gap-x-4">
                        <div className={`flex flex-row gap-x-2 mb-2 md:hidden`}>
                            {
                                filtersChanged && (
                                    <button 
                                        className="w-fit md:hidden flex flex-row gap-x-2 mb-4 md:mb-0 text-xs leading-tight px-4 py-2 items-center bg-cyan-200 hover:bg-cyan-300 active:shadow-lg transition duration-150 ease-in-out uppercase text-sp text-black rounded-full"
                                        onClick={(() => {
                                            setFilters(defaultFilters);
                                            setUserMeta(userMetaDefault);
                                            setVideoType("unsorted");
                                            setVideoTypeLoading(true);
                                        })}
                                    >
                                        <FaArrowLeft />
                                        Back
                                    </button>
                                )
                            }
                            <FeedSort current={filters.sort} onClick={((s) => {
                                if (videoTypeLoading) return;
                                setFilters({
                                    ...filters,
                                    sort: s || "chronological-descend"
                                });
                                setVideoTypeLoading(true);
                            })} hiddenResponsive />
                        </div>
                        {
                            !userMeta.active && (
                                <>
                                    <div className="flex flex-col gap-y-1 md:flex-row md:gap-y-0 md:gap-x-4 md:items-center">
                                        {
                                            filtersChanged && (
                                                <button 
                                                    className="w-fit hidden md:flex flex-row gap-x-2 mb-4 md:mb-0 text-xs leading-tight px-4 py-2 items-center bg-cyan-200 hover:bg-cyan-300 active:shadow-lg transition duration-150 ease-in-out uppercase text-sp text-black rounded-full"
                                                    onClick={(() => {
                                                        setFilters(defaultFilters);
                                                        setUserMeta(userMetaDefault);
                                                        setVideoType("unsorted");
                                                        setVideoTypeLoading(true);
                                                    })}
                                                >
                                                    <FaArrowLeft />
                                                    Back
                                                </button>
                                            )
                                        }
                                        <div className="flex flex-row gap-x-4 items-center text-2xl font-BreezeAltHeader">
                                            All { filters.favourite == true && "featured" } {sortExpression.name.toLowerCase()}
                                            <button className="md:hidden" onClick={(() => setFiltersOpen(!filtersOpen))}>
                                                <FaFilter className="text-xl hover:text-gray-300 transition duration-150 ease-in-out" />
                                            </button>
                                        </div>
                                        <span className="text-base font-BreezeButton font-semibold text-gray-300">
                                            {
                                                videoTypeLoading 
                                                ? `Loading..`
                                                : totalSearchResults === 0 ?
                                                    `No results found`
                                                : `Showing ${videos.length} of ${totalSearchResults} results`
                                            }
                                        </span>
                                    </div>
                                </>
                            )
                        }
                        {
                            userMeta.active && (
                                <>
                                    <div className="flex flex-col gap-y-2 md:flex-row md:gap-y-0 md:gap-x-4 md:items-center">
                                        {
                                            filtersChanged && (
                                                <button 
                                                    className="w-fit hidden md:flex flex-row gap-x-2 mb-4 md:mb-0 text-xs leading-tight px-4 py-2 items-center bg-cyan-200 hover:bg-cyan-300 active:shadow-lg transition duration-150 ease-in-out uppercase text-sp text-black rounded-full"
                                                    onClick={(() => {
                                                        setFilters(defaultFilters);
                                                        setUserMeta(userMetaDefault);
                                                        setVideoType("unsorted");
                                                        setVideoTypeLoading(true);
                                                    })}
                                                >
                                                    <FaArrowLeft />
                                                    Back
                                                </button>
                                            )
                                        }
                                        <div className="flex flex-row items-center gap-x-4">
                                            <div className="flex flex-row gap-x-4 sm:gap-x-2 items-center md:flex-row">
                                                <img referrerPolicy="no-referrer" className="rounded-xl w-12 md:w-8" alt={"Continuity"} src={userMeta.avatar} />
                                                <div className="flex flex-col md:flex-row md:gap-x-2">
                                                    <h1 className="text-2xl font-medium font-BreezeAltHeader">
                                                        {
                                                            userMeta.editor ? <>{filters.favourite ? "Featured" : "" } {(filters.favourite ? sortExpression.name.toLowerCase() : sortExpression.name)} edited by <b>{userMeta.name}</b></> : <><b>{userMeta.name}</b>&apos;s {filters.favourite ? "featured" : "" } {sortExpression.name.toLowerCase()} { filters.editor ? <>edited by <b>{filters.editor === "solo" ? "Kooleyy" : "Continuity"}</b></> : ""  }</>
                                                        }
                                                    </h1>
                                                </div>
                                                <button className="md:hidden" onClick={(() => setFiltersOpen(!filtersOpen))}>
                                                    <FaFilter className="text-xl hover:text-gray-300 transition duration-150 ease-in-out" />
                                                </button>
                                            </div>
                                        </div>
                                        <span className="text-base font-BreezeButton font-semibold text-gray-300">
                                            {
                                                videoTypeLoading 
                                                ? `Loading..`
                                                : totalSearchResults === 0 ?
                                                    `No results found`
                                                : `Showing ${videos.length} of ${totalSearchResults} results`
                                            }
                                        </span>
                                    </div>
                                </>
                            )
                        }
                    </div>
                    <div className={`hidden md:flex flex-col items-end md:flex-row gap-x-4 gap-y-4`}>
                        {filterDiv}
                    </div>
                </div>
                <div className="hidden md:block">
                    <FeedSort current={filters.sort} onClick={((s) => {
                        if (videoTypeLoading) return;
                        setFilters({
                            ...filters,
                            sort: s || "chronological-descend"
                        });
                        setVideoTypeLoading(true);
                    })} />
                </div>
            </div>
            <div className={`${filtersOpen ? "flex" : "hidden"} z-[40] md:hidden flex-col md:flex-row gap-x-4 gap-y-4`}>
                {filterDiv}
            </div>
            {(() => {
                if (loading) {
                    const k = [...Array(40).keys()];
                    return (
                        <>
                            <div 
                                className="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-x-4 gap-y-8"
                            >
                                {
                                    (k).map((i) => (
                                        <LoadingThumbnail key={i} />
                                    ))
                                }
                            </div>
                        </>
                    );
                } else {
                    const k = [...Array(15).keys()];
                    return (
                        <>
                            <InfiniteScroll 
                                className="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-x-4 gap-y-8"
                                dataLength={videos.length}
                                next={fetchVideos}
                                hasMore={more}
                                loader={(k).map((i) => (
                                    <LoadingThumbnail key={i} />
                                ))}
                            >
                                {
                                    videos.map((video, index) => { 
                                        if (video === null) return;
                                        return (
                                            <VideoThumbnail timestamp={new Date(video.timestamp)} key={index} playlistId={video.playlistId} sort={video.sort} href={`https://youtube.com/watch?v=${video.id}`} thumb={`https://i3.ytimg.com/vi_webp/${video.id}/maxresdefault.webp`} title={video.title} author={video.channel.name} authorPhoto={pageContext?.carry?.clients.find(c => c.id === video.channel.id)?.thumbnail?.high?.url} authorHref={`https://youtube.com/channel/${video.channel.id}`} duration={video.duration} views={video.social.views} authorId={video.channel.id} />
                                        )
                                    })
                                }
                            </InfiniteScroll>
                            {
                                ((videos.length === 0)) && (
                                    <div className="flex flex-col justify-center items-center w-full py-8 gap-y-4">
                                        <Image width="96" height="96" referrerPolicy="no-referrer" className="w-32 h-32" alt={"Cookie Munch"} src={"/cookieEat.gif"} />
                                        <p className="text-center text-lg text-gray-400">
                                            <b>There&apos;s nothing here?</b>
                                        </p>
                                    </div>
                                )
                            }
                            {
                                ((videos.length !== 0) && !more) && (
                                    <div className="flex flex-col justify-center items-center w-full py-8 gap-y-4">
                                        <Image width="96" height="96" referrerPolicy="no-referrer" className="w-32 h-32" alt={"Cookie Munch"} src={"/cookieEat.gif"} />
                                        <p className="text-center text-lg text-gray-400">
                                            <b>Yay! You&apos;ve seen it all.</b>
                                        </p>
                                    </div>
                                )
                            }
                        </>
                    );
                };
            })()}
        </main>
    );
};
